import { AlertTriangle, ShieldAlert } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const COPY = {
  en: {
    danger: "If you are in immediate danger, call 911.",
    note: 'Internet activity may be monitored. Use a safe device when possible. The "Quick Exit" button below will send you away from this site without warning.',
    button: "Quick Exit",
  },
  es: {
    danger: "Si está en peligro inmediato, llame al 911.",
    note: 'La actividad en Internet puede ser monitoreada. Use un dispositivo seguro cuando sea posible. El botón "Salida Rápida" lo enviará fuera de este sitio sin advertencia.',
    button: "Salida Rápida",
  },
};

/**
 * Banner shown at the top of survivor-facing pages (Get Support, Referrals).
 * Includes an immediate quick-exit button that redirects to a neutral site
 * with no confirmation dialog, per survivor-safety best practices.
 */
export default function SafetyBanner() {
  const { language } = useLanguage();
  const c = COPY[language] || COPY.en;

  const quickExit = () => {
    window.open("https://www.google.com", "_newtab");
    window.location.replace("https://www.google.com");
  };

  return (
    <div className="bg-red-50 border-b border-red-200" data-testid="safety-banner" role="alert">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-4 flex-wrap">
        <div className="flex items-start gap-2 text-sm text-red-900 flex-1 min-w-[280px]">
          <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold">{c.danger}</p>
            <p className="text-xs text-red-800 mt-0.5">{c.note}</p>
          </div>
        </div>
        <button
          onClick={quickExit}
          className="flex items-center gap-1.5 bg-red-600 hover:bg-red-700 text-white font-bold text-xs uppercase tracking-wider px-4 py-2 rounded"
          data-testid="quick-exit-btn"
        >
          <ShieldAlert className="w-3.5 h-3.5" />
          {c.button}
        </button>
      </div>
    </div>
  );
}
